import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { PHONE_CONFIG } from '@ib-core/config/phone-config';
import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';
import { environment } from '@ib-env/environment';
import { DocumentsRequiredValidator } from '@ib-shared/validation/documents-required.validator';
import { PpsValidator } from '@ib-shared/validation/pps.validator';
import { VatValidator } from '@ib-shared/validation/vat.validator';
import * as dayjs from 'dayjs';
import { BehaviorSubject } from 'rxjs';

import { ISignUpStep } from '../interfaces/sign-up-step.intf';
import { ISignUpWizardBtnsState } from '../interfaces/sign-up-wizard-btns-state.intf';

@Injectable()
export class SignUpStateService {
  public isUserFilledFirstStep = false;
  public isUserRegistered = false;
  public isSmsWasSentAtLeastOneTime = false;

  // root form
  public readonly rootForm$ = new BehaviorSubject<FormGroup>(new FormGroup({}));

  // objective
  public savingForFormCtrl = new FormControl(undefined, [Validators.required]);
  public savingForOtherFormCtrl = new FormControl(undefined, [
    Validators.required,
    Validators.minLength(2),
    Validators.maxLength(200),
  ]);
  public whatForFormCtrl = new FormControl(undefined, [Validators.required]);
  public whatForOtherFormCtrl = new FormControl(undefined, [
    Validators.required,
    Validators.minLength(2),
    Validators.maxLength(200),
  ]);
  public currencyHowMuchFormCtrl = new FormControl(undefined, [
    Validators.required,
  ]);

  // documents
  public ppsFormCtrl = new FormControl(undefined, []);
  public vatFormCtrl = new FormControl(undefined, []);
  public ppsValidators = [
    Validators.required,
    Validators.minLength(8),
    Validators.maxLength(9),
    PpsValidator(),
  ];
  public vatValidators = [
    Validators.required,
    Validators.minLength(8),
    Validators.maxLength(8),
    VatValidator(),
  ];
  public docsMainFormGroup = new FormGroup({}, [
    DocumentsRequiredValidator({
      minAmount: 1,
      errorName: FORM_ERRORS.ATTACHED_DOCS_REQUIRED,
    }),
  ]);
  public docsFormGroupsMap: Record<string, FormGroup> = {};

  // steps
  public readonly steps$ = new BehaviorSubject<Array<ISignUpStep>>([]);
  public readonly currStepIndex$ = new BehaviorSubject<number>(
    !environment.production ? 0 : 0,
  );

  // phone
  public readonly disablePhone$ = new BehaviorSubject<boolean>(false);
  public readonly phoneId$ = new BehaviorSubject<string>(undefined);
  public phoneConfirmedFormCtrl = new FormControl(false, [
    Validators.requiredTrue,
  ]);

  // bank
  public currencyBankFormCtrl = new FormControl(undefined, [
    Validators.required,
  ]);

  // loading
  public readonly isPhoneCheckLoading$ = new BehaviorSubject<boolean>(false);
  public readonly isEmailCheckLoading$ = new BehaviorSubject<boolean>(false);
  public readonly isRegisterLoading$ = new BehaviorSubject<boolean>(false);
  public readonly isSendSmsLoading$ = new BehaviorSubject<boolean>(false);
  public readonly isConfirmCodeLoading$ = new BehaviorSubject<boolean>(false);

  // phone confirm code
  public validDuringSec = PHONE_CONFIG.SIX_DIGIT_CODE_VALID_DURING_SEC;
  public readonly codeExpireAt$ = new BehaviorSubject<dayjs.Dayjs | null>(null);
  public tooltipTimeout: any;

  // btns state
  public readonly btnsState$ =
    new BehaviorSubject<ISignUpWizardBtnsState | null>(null);
}
